"use client";
import { Children, memo, PropsWithChildren, useEffect, useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";

import Box from "@mui/material/Box";
import { IconButton, styled } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import { cn } from "@onair/utils/cn";
import { SwiperOptions } from "swiper/types";

interface CarouselProps extends PropsWithChildren {}
const Carousel: React.FC<CarouselProps> = ({ children }) => {
	const swiperRef = useRef<SwiperType>();

	const pagination: SwiperOptions["pagination"] = {
		clickable: true,
		el: ".swiper-edoc__pagination",
	};
	useEffect(() => {
		const handleUpdateSwiper = () => {
			swiperRef.current?.update();
		};
		window.addEventListener("resize", handleUpdateSwiper);
		return () => {
			window.removeEventListener("resize", handleUpdateSwiper);
		};
	}, []);

	return (
		<CarouselContainer component="div" className="relative carousel-edoc">
			<Swiper
				slidesPerView={1}
				spaceBetween={24}
				breakpoints={{
					1200: {
						spaceBetween: 24,
						slidesPerView: 3,
					},
					900: {
						spaceBetween: 16,
						slidesPerView: 3,
					},
					600: {
						spaceBetween: 16,
						slidesPerView: 2,
					},
				}}
				pagination={pagination}
				modules={[Pagination, Navigation]}
				onSwiper={(swiper) => {
					swiperRef.current = swiper;
				}}
				className="swiper-edoc"
			>
				{Children.map(children, (child, _index) => (
					<SwiperSlide key={_index} className="box-border h-auto">
						{child}
					</SwiperSlide>
				))}
			</Swiper>
			<Box
				component="div"
				className={cn(
					"flex justify-between items-center px-0 z-10 mt-3",
					"w-full right-0 left-0",
				)}
			>
				<IconButton
					className="w-10 h-10 justify-center items-center pointer-events-auto"
					onClick={() => swiperRef.current?.slidePrev()}
				>
					<Iconify width={24} icon="solar:arrow-left-outline" />
				</IconButton>
				<div className="swiper-edoc__pagination flex items-center justify-center flex-1 gap-x-[2px]"></div>
				<IconButton
					onClick={() => swiperRef.current?.slideNext()}
					className="w-10 h-10 justify-center items-center pointer-events-auto"
				>
					<Iconify width={24} icon="solar:arrow-right-outline" />
				</IconButton>
			</Box>
		</CarouselContainer>
	);
};
export default memo(Carousel);

const CarouselContainer = styled(Box)`
	& {
		.swiper-edoc__pagination {
			.swiper-pagination-bullet {
				background-color: white;
			}
		}
	}
`;
